// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Main Container */
.payment-container {
    display: flex;
    flex-direction: column;
    align-items: center;
    padding: 20px;
    max-width: 400px;
    margin: 0 auto;
  }
  
  /* Title */
  .payment-title {
    font-size: 2rem;
    font-weight: bold;
    margin-bottom: 20px;
  }
  
  /* Form */
  .payment-form {
    width: 100%;
  }
  
  /* Row Layout */
  .payment-row {
    display: flex;
    gap: 10px;
    margin-bottom: 15px;
  }
  
  /* Input Group */
  .payment-input-group {
    display: flex;
    flex-direction: column;
    margin-bottom: 15px;
    flex: 1 1;
  }
  
  /* Input Fields */
  .payment-input {
    padding: 10px;
    font-size: 1rem;
    border: 1px solid #ccc;
    border-radius: 5px;
  }
  
  /* Submit Button */
  .payment-submit-button {
    width: 100%;
    padding: 10px;
    font-size: 1rem;
    font-weight: bold;
    color: #fff;
    background-color: #007bff;
    border: none;
    border-radius: 5px;
    cursor: pointer;
    margin-top: 15px;
  }
  
  .payment-submit-button:hover {
    background-color: #0056b3;
  }
  `, "",{"version":3,"sources":["webpack://./src/styles/Payment.css"],"names":[],"mappings":"AAAA,mBAAmB;AACnB;IACI,aAAa;IACb,sBAAsB;IACtB,mBAAmB;IACnB,aAAa;IACb,gBAAgB;IAChB,cAAc;EAChB;;EAEA,UAAU;EACV;IACE,eAAe;IACf,iBAAiB;IACjB,mBAAmB;EACrB;;EAEA,SAAS;EACT;IACE,WAAW;EACb;;EAEA,eAAe;EACf;IACE,aAAa;IACb,SAAS;IACT,mBAAmB;EACrB;;EAEA,gBAAgB;EAChB;IACE,aAAa;IACb,sBAAsB;IACtB,mBAAmB;IACnB,SAAO;EACT;;EAEA,iBAAiB;EACjB;IACE,aAAa;IACb,eAAe;IACf,sBAAsB;IACtB,kBAAkB;EACpB;;EAEA,kBAAkB;EAClB;IACE,WAAW;IACX,aAAa;IACb,eAAe;IACf,iBAAiB;IACjB,WAAW;IACX,yBAAyB;IACzB,YAAY;IACZ,kBAAkB;IAClB,eAAe;IACf,gBAAgB;EAClB;;EAEA;IACE,yBAAyB;EAC3B","sourcesContent":["/* Main Container */\n.payment-container {\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n    padding: 20px;\n    max-width: 400px;\n    margin: 0 auto;\n  }\n  \n  /* Title */\n  .payment-title {\n    font-size: 2rem;\n    font-weight: bold;\n    margin-bottom: 20px;\n  }\n  \n  /* Form */\n  .payment-form {\n    width: 100%;\n  }\n  \n  /* Row Layout */\n  .payment-row {\n    display: flex;\n    gap: 10px;\n    margin-bottom: 15px;\n  }\n  \n  /* Input Group */\n  .payment-input-group {\n    display: flex;\n    flex-direction: column;\n    margin-bottom: 15px;\n    flex: 1;\n  }\n  \n  /* Input Fields */\n  .payment-input {\n    padding: 10px;\n    font-size: 1rem;\n    border: 1px solid #ccc;\n    border-radius: 5px;\n  }\n  \n  /* Submit Button */\n  .payment-submit-button {\n    width: 100%;\n    padding: 10px;\n    font-size: 1rem;\n    font-weight: bold;\n    color: #fff;\n    background-color: #007bff;\n    border: none;\n    border-radius: 5px;\n    cursor: pointer;\n    margin-top: 15px;\n  }\n  \n  .payment-submit-button:hover {\n    background-color: #0056b3;\n  }\n  "],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
